import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import {
  type UseFlightCategorySelectionParams,
  useFlightCategorySelection,
} from "@tenant/flights";
import { RadioGroup } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FlightCategorySelection.module.scss";

export interface IFlightCategoryToggleProps
  extends UseFlightCategorySelectionParams {
  className?: string;
}

export const FlightCategorySelection = (props: IFlightCategoryToggleProps) => {
  const { selectedTripCategoryState, getCategoryOptions, handleOnChange } =
    useFlightCategorySelection(props);

  const styles = useFlightStyles(
    CoreFlightsComponent.FlightCategorySelection,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreFlightsComponent.FlightCategorySelection
  );

  const radioGroupClassNames = {
    container: clsx(block, cn("radio-group-container")),
    itemContainer: cn("radio-item-container"),
  };

  return (
    <RadioGroup
      options={getCategoryOptions()}
      selectedOption={selectedTripCategoryState}
      onSelectValue={(value) => handleOnChange(value)}
      classNames={radioGroupClassNames}
    />
  );
};
